// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_qe-0";
export var animationContainer = "_qe-1";
export var itemPrice = "_qe-a";
export var itemizedContent = "_qe-9";
export var itemizedHeader = "_qe-7";
export var itemizedRow = "_qe-8";
export var itemizedSection = "_qe-6";
export var modalContent = "_qe-2";
export var orderName = "_qe-3";
export var refundOption = "_qe-4";
export var refundOptionsContainer = "_qe-5";
export var shippingLabel = "_qe-b";
export var totalRow = "_qe-c";